// pages/admin/AdminContactSubmissions.js

import React, { useState, useEffect } from 'react';
import { Table, Modal, Button, Spinner, Alert } from 'react-bootstrap';
import { Eye } from 'lucide-react';
// Assuming this path is correct for your project structure
import { fetchContactSubmissionsApi, fetchContactSubmissionDetailsApi } from '../../../services/adminApi';
import './AdminContactSubmissions.css';
const AdminContactSubmissions = () => {
  const [submissions, setSubmissions] = useState([]);
  const [selectedSubmission, setSelectedSubmission] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const loadSubmissions = async () => {
      try {
        setLoading(true);
        // This calls the fetchContactSubmissionsApi function from services/api.js
        // const data = await fetchContactSubmissionsApi();
        // setSubmissions(data);
        const res = await fetchContactSubmissionsApi();
          setSubmissions(res.data);
        setError('');
      } catch (err) {
        // Display a user-friendly error message
        setError(`Failed to load submissions: ${err.message || 'An unknown error occurred.'}`);
        console.error("Frontend error loading submissions:", err);
      } finally {
        setLoading(false);
      }
    };
    loadSubmissions();
  }, []);

  const handleViewDetails = async (id) => {
    try {
        // This calls fetchContactSubmissionDetailsApi(id) from services/api.js
        // const details = await fetchContactSubmissionDetailsApi(id);
        // setSelectedSubmission(details);
         const res = await fetchContactSubmissionDetailsApi(id);
        setSelectedSubmission(res.data);
        setShowModal(true);
    } catch (err) {
        // Display a user-friendly error message
        setError(`Failed to load submission details: ${err.message || 'An unknown error occurred.'}`);
        console.error("Frontend error loading submission details:", err);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedSubmission(null); // Clear the selected submission when modal closes
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    );
  }

  return (
    // <div className="container mt-4">
    <div className="container-fluid mt-4 custom-page">
      <h2>Contact Form Submissions</h2>
      {error && <Alert variant="danger">{error}</Alert>}

      <Table className="custom-admin-table" responsive>
        <thead className="custom-thead" >
          <tr>
            <th>#</th>
            <th>Name</th>
            <th>Email</th>
            <th>Mobile</th>
            <th>Status</th>
            <th>Received On</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody className='custom-tbody'>
          {submissions.map((sub, index) => (
            <tr key={sub.id}>
              <td>{index + 1}</td>
              <td>{`${sub.firstName} ${sub.lastName}`}</td>
              <td>{sub.email}</td>
              <td>{sub.mobile}</td>
              <td><span className={`badge bg-${sub.status === 'New' ? 'primary' : 'secondary'}`}>{sub.status}</span></td>
              <td>{new Date(sub.created_at).toLocaleString()}</td>
              <td>
                <Button variant="outline-primary" size="sm" onClick={() => handleViewDetails(sub.id)}>
                  <Eye size={16} /> View
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      {/* Details Modal */}
     <Modal show={showModal} onHide={handleCloseModal} size="lg" data-bs-theme="dark"> {/* Added data-bs-theme="dark" */}
      <Modal.Header closeButton>
        <Modal.Title>Submission Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {selectedSubmission ? (
          <div>
            <p><strong>From:</strong> {`${selectedSubmission.firstName} ${selectedSubmission.lastName}`}</p>
            <p><strong>Email:</strong> {selectedSubmission.email}</p>
            <p><strong>Mobile:</strong> {selectedSubmission.mobile}</p>
            <p><strong>Received:</strong> {new Date(selectedSubmission.created_at).toLocaleString()}</p>
            {/* For dark mode, you might want to adjust badge colors as well */}
            <p><strong>Status:</strong> <span className={`badge bg-${selectedSubmission.status === 'New' ? 'primary' : 'secondary'}`}>{selectedSubmission.status}</span></p>
            <hr />
            <h5>Message:</h5>
            <p style={{ whiteSpace: 'pre-wrap' }}>{selectedSubmission.message}</p>
          </div>
        ) : (
          <p>Loading details...</p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleCloseModal}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
    </div>
  );
};

export default AdminContactSubmissions;